import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Ship, Plane, Truck } from 'lucide-react';
import './NotFound.css';

const NotFound = () => {
  return (
    <div className="not-found">
      <div className="not-found__bg">
        <Ship size={100} className="not-found__icon not-found__icon--1" />
        <Plane size={80} className="not-found__icon not-found__icon--2" />
        <Truck size={90} className="not-found__icon not-found__icon--3" />
      </div>
      <div className="container not-found__content">
        <h1 className="not-found__code">404</h1>
        <h2 className="not-found__title">Page Not Found</h2>
        <p className="not-found__text">
          The page you're looking for may have moved or is no longer available.
        </p>
        <div className="not-found__actions">
          <Link to="/" className="btn btn-primary btn-lg">
            Go Home <ArrowRight size={18} />
          </Link>
          <Link to="/contact" className="btn btn-outline btn-lg">
            Get in Touch
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
